import { IntlProvider } from "react-intl";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import antdTW from "antd/locale/zh_TW";
import antdEN from "antd/locale/en_US";
import en from "src/assets/i18n/en";
import tw from "src/assets/i18n/tw";
import AntdStyles from "src/styles/antdStyles";
import GlobalStyle from "src/styles/globalStyle";
import ResetStyle from "src/styles/resetStyle";
import { useSelector } from "src/redux/store";
import darkTheme from "./darkTheme.json";
import lightTheme from "./lightTheme.json";

export default ({ children }) => {
    const { theme, locale } = useSelector((state) => state.themeReducer);
    const themes = { dark: darkTheme, light: lightTheme };
    const locales = {
        en: { reactLocale: en, antdLocale: antdEN },
        "zh-TW": { reactLocale: tw, antdLocale: antdTW }
    };

    return (
        <IntlProvider
            locale={locale}
            key={locale} defaultLocale="en"
            messages={locales[locale].reactLocale}
        >
            <ConfigProvider locale={locales[locale].antdLocale}>
                <ThemeProvider theme={themes[theme]}>
                    <ResetStyle />
                    <GlobalStyle />
                    <AntdStyles />
                    {children}
                </ThemeProvider>
            </ConfigProvider>
        </IntlProvider>
    );
};